import GetAllApplications from "@/components/Lead/Applications/GetAllApplications";
import Loader from "@/components/Loader/Loader";
import PermissionChecker from "@/components/PrivacyComponent/PermissionChecker";
import { Suspense, lazy } from "react";
import { Route } from "react-router-dom";

const ApplicationDetails = lazy(() => import("@/components/Agent/Applications/ApplicationDetails"));

const ApplicationRoutes = [
    <Route
        path="application"
        element={
            <Suspense fallback={<Loader />}>
                <PermissionChecker permission={["readAll-application", "readSingle-application"]}>
                    <GetAllApplications />
                </PermissionChecker>
            </Suspense>
        }
        key="application"
    />,
    <Route
        path="application/:id"
        element={
            <Suspense fallback={<Loader />}>
                <PermissionChecker permission={["readAll-application", "readSingle-application"]}>
                    <ApplicationDetails />
                </PermissionChecker>
            </Suspense>
        }
        key="application-details"
    />,
];

export default ApplicationRoutes;
